
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/before-bidding",
      function () {
        return require("private-next-pages/content/buying/before-bidding.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/before-bidding"])
      });
    }
  